import React from 'react';
import { FormControl, FormLabel, Switch, NumberInput, NumberInputField } from '@chakra-ui/react';

const ScrollOptions = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>Scroll Status</FormLabel>
        <Switch
          name="actionProps.scroll.status"
          isChecked={formik.values.actionProps.scroll.status}
          onChange={formik.handleChange}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Scroll Percentage</FormLabel>
        <NumberInput min={0} max={100}>
          <NumberInputField
            name="actionProps.scroll.percentage"
            value={formik.values.actionProps.scroll.percentage}
            onChange={(valueString) => formik.setFieldValue('actionProps.scroll.percentage', valueString.target.value)}
          />
        </NumberInput>
      </FormControl>
    </>
  );
};

export default ScrollOptions;